'use client';
import React from 'react';

interface BlogPost {
  id: number;
  date: string;
  month: string;
  year: string;
  title: string;
  excerpt: string;
  image: string;
  alt: string;
  href: string;
  tag: string;
}

const blogPosts: BlogPost[] = [
{
  id: 1,
  date: '14',
  month: 'July',
  year: '2026',
  title: 'Hyderabad\'s Peripheral Corridors: The Next Decade of Wealth Creation in Plotted Real Estate',
  excerpt: 'As Hyderabad\'s IT and infrastructure boom pushes outward, premium plotted ventures along the RRR and beyond are quietly becoming the most powerful wealth-building instruments for discerning investors. Here\'s why the next 10 years belong to those who act now.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_10b262cf7-1767639759419.png",
  alt: 'Aerial view of Hyderabad city skyline with expanding residential corridors and plotted developments',
  href: '#',
  tag: 'Market Insight'
},
{
  id: 2,
  date: '03',
  month: 'June',
  year: '2026',
  title: 'From Land to Legacy: How HNI Investors Are Redefining Generational Wealth Through Premium Plots Near Hyderabad',
  excerpt: 'High-net-worth investors are increasingly turning to DTCP, HMDA & RERA-approved plotted developments as the cornerstone of multi-generational wealth strategies. Discover how Neo Capital Group\'s ventures are setting a new benchmark for secure, appreciating land assets.',
  image: "https://img.rocket.new/generatedImages/rocket_gen_img_1fcf5fc89-1772295305155.png",
  alt: 'Premium gated community plotted development with wide roads and green landscaping near Hyderabad',
  href: '#',
  tag: 'Investor Strategy'
}];



export default function BlogSection() {
  return (
    <section id="blogs" className="py-16 md:py-20 bg-brand-gray-light/20">
      <div className="container mx-auto px-4 max-w-6xl">
        {/* Header */}
        <div className="text-center mb-12">
          <h6 className="text-brand-turmeric font-avenir text-sm font-semibold uppercase tracking-widest mb-2">
            # Neo Capital Group
          </h6>
          <h2 className="text-3xl md:text-4xl font-bold text-brand-dark font-avenir mb-3">
            Latest Insights
          </h2>
          <hr className="border-0 h-0.5 bg-brand-green w-20 mx-auto mb-4" />
          <p className="text-brand-gray font-avenir text-sm max-w-xl mx-auto">
            Expert perspectives on Hyderabad's real estate landscape, investment strategies, and premium plot development.
          </p>
        </div>

        {/* Blog Grid — 2 columns, large cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {blogPosts.map((post) =>
          <article
            key={post.id}
            className="bg-white rounded-2xl overflow-hidden shadow-card hover:shadow-card-hover transition-all duration-300 group flex flex-col">
            
              {/* Image */}
              <div className="relative overflow-hidden h-60">
                <img
                src={post.image}
                alt={post.alt}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
              
                <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                {/* Tag badge */}
                <span className="absolute top-4 left-4 bg-brand-turmeric text-white font-avenir text-xs font-bold px-3 py-1 rounded-full uppercase tracking-wide">
                  {post.tag}
                </span>
                {/* Date badge */}
                <div className="absolute bottom-4 left-4 flex items-end gap-2">
                  <span className="text-white font-avenir text-4xl font-bold leading-none">{post.date}</span>
                  <div className="flex flex-col leading-tight">
                    <span className="text-white/90 font-avenir text-sm font-semibold">{post.month}</span>
                    <span className="text-white/70 font-avenir text-xs">{post.year}</span>
                  </div>
                </div>
              </div>

              {/* Content */}
              <div className="p-6 flex flex-col flex-1">
                <h3 className="text-brand-dark font-bold font-avenir text-base leading-snug mb-3 group-hover:text-brand-green transition-colors duration-200">
                  <a href={post.href}>{post.title}</a>
                </h3>
                <p className="text-brand-gray font-avenir text-sm leading-relaxed mb-4 flex-1">
                  {post.excerpt}
                </p>
                <a
                href={post.href}
                className="inline-flex items-center text-brand-green font-avenir text-sm font-semibold hover:text-brand-turmeric transition-colors duration-200 group/link mt-auto">
                
                  Read Full Article
                  <svg className="ml-2 w-4 h-4 group-hover/link:translate-x-1 transition-transform duration-200" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </a>
              </div>
            </article>
          )}
        </div>
      </div>
    </section>);

}